import { render, staticRenderFns } from "./TrailEditorComponent.vue?vue&type=template&id=049e58e1&scoped=true"
import script from "./TrailEditorComponent.vue?vue&type=script&lang=js"
export * from "./TrailEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e58e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049e58e1')) {
      api.createRecord('049e58e1', component.options)
    } else {
      api.reload('049e58e1', component.options)
    }
    module.hot.accept("./TrailEditorComponent.vue?vue&type=template&id=049e58e1&scoped=true", function () {
      api.rerender('049e58e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/formComponents/style-components/TrailEditorComponent.vue"
export default component.exports